/*
 *
 * ManageApiKeyModal
 *
 * @version 1.0.0
 * @author Christopher Monti
 * @since 25-Mar-2025
 */

import ManageApiKeyModal from './ManageApiKeyModalContainer'

export default ManageApiKeyModal
